import { BookOpen, Users, Sparkles, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GiveButter } from "@/components/GiveButter";
import { LINKS } from "@/lib/api";

const IMPACT = [
  { icon: BookOpen, amt: "$25", body: "Puts 10 brand-new books into the hands of children at a Pages of Progress event." },
  { icon: Sparkles, amt: "$100", body: "Helps host a cultural celebration that brings hundreds of neighbors together." },
  { icon: Users, amt: "$500", body: "Sponsors a young leader through a full season of mentorship and workshops." },
];

export default function Donate() {
  return (
    <div data-testid="donate-page">
      <section className="bg-ink crosshatch radial-glow pt-[68px]" data-testid="donate-hero">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16 lg:py-20 relative z-10">
          <span className="eyebrow">Donate</span>
          <h1 className="font-serif-eth font-light text-white mt-6 text-5xl lg:text-[64px] leading-[1.03] max-w-3xl">
            Your gift builds <em>community.</em>
          </h1>
          <p className="font-body-eth text-white/60 text-lg mt-6 max-w-2xl leading-relaxed">
            Ethos Foundation is a 501(c)(3) nonprofit. Every dollar goes directly to literacy, cultural celebration, and youth leadership across Boston.
          </p>
        </div>
      </section>

      <section className="bg-cream">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-[1fr_460px] gap-12 items-start">
          <div>
            <Reveal><span className="eyebrow dark">Where It Goes</span></Reveal>
            <Reveal delay={80}>
              <h2 className="font-serif-eth font-light text-ink text-4xl lg:text-5xl mt-5">Every gift, <em>measured in impact.</em></h2>
            </Reveal>
            <div className="mt-10 flex flex-col gap-4">
              {IMPACT.map((it, i) => (
                <Reveal key={it.amt} delay={i * 100}>
                  <div className="group eth-card bg-white border border-[var(--line)] p-6 flex gap-5 items-center">
                    <div className="shrink-0 w-20 text-center border-r border-[var(--line)] pr-5">
                      <it.icon size={22} className="text-teal mx-auto" />
                      <div className="font-serif-eth text-2xl text-ink mt-1">{it.amt}</div>
                    </div>
                    <p className="font-body-eth text-mute text-sm leading-relaxed">{it.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={200}>
              <div className="mt-8 font-body-eth text-sm text-mute">
                Prefer to give another way? <a href={`mailto:${LINKS.email}`} className="text-teal font-medium hover:underline">Email us</a> about sponsorships and matching gifts.
              </div>
            </Reveal>
          </div>

          <Reveal delay={120}>
            <div className="bg-white border border-[var(--line)] p-7 lg:sticky lg:top-24" style={{ borderRadius: 2 }}>
              <h3 className="font-serif-eth text-2xl text-ink">Give <em>securely.</em></h3>
              <p className="font-body-eth text-mute text-sm mt-2">Powered by GiveButter · tax-deductible</p>
              <div className="mt-5 min-h-[140px]">
                <GiveButter widgetId="Ly87xj" />
              </div>
              <a href={LINKS.donate} target="_blank" rel="noreferrer" data-testid="donate-giveburter-link" className="btn-gold w-full text-center font-body-eth text-sm font-semibold py-3.5 mt-4 inline-flex items-center justify-center gap-2">
                Donate Now <ArrowUpRight size={16} />
              </a>
              <div className="font-body-eth text-[11px] text-mute text-center mt-4">
                Ethos Foundation · 501(c)(3) · Boston, MA
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
